<template id="Home">
  <div>
    <br />
    <div v-if="loading" class="loading">
      <div class="text-center">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
    </div>
    <div v-else>
      <b-row>
        <b-col lg="8" class="my-1">
          <h3>
            <b-icon-building /> Organizations
            <b-button v-if="showAddOrgButton" :to="`/add`" class="ml-auto" variant="primary">
              + Add Org
            </b-button>
          </h3>
        </b-col>
      </b-row>
      <div v-if="chunks">
        <b-row v-for="(chunk, idx) in chunks" :key="idx" class="orgRow">
          <b-col cols="4" v-for="org in chunk" :key="org.orgid">
            <b-card bg-variant="light" no-body>
              <b-card-header>
                <b-link :to="`/org/${org.orgid}`">{{ org.login }}</b-link>
              </b-card-header>
              <b-card-body>
                <b-card-text>{{ org.description }} </b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <h3>No Organizations Found!</h3>
        <p>Click "Add Org" to add an organization to the dashboard</p>
        <b-button v-if="showAddOrgButton" :to="`/add`" class="ml-auto" variant="primary">
          + Add Org
        </b-button>
      </div>
      <br />
      <b-card no-body>
        <b-tabs card content-class="mt-2" align="left">
          <b-tab active>
            <template v-slot:title>
              <div class="repositories-title">
              <b-icon-book /> Repositories
              <b-badge v-if="items" class="repositories-badge">{{ items.length }}</b-badge>
            </div>
            </template>
            <b-card-text>
              <repo-table :repos="items" />
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import RepoTable from "../components/RepoTable.vue";
import _ from "lodash";
import {
  retrieveAuthTokens,
  parseAuthTokens,
} from "../common/authentication_utils";
export default {
  name: "Home",
  data() {
    return {
      items: [],
      loading: true,
      chunks: [],
      showAddOrgButton: false,
    };
  },
  mounted() {
    const { decodedAccessToken } = parseAuthTokens(...Object.values(retrieveAuthTokens()));
    this.showAddOrgButton = decodedAccessToken['cognito:groups'].includes(process.env.VUE_APP_ADMIN_GROUP)
  },
  components: {
    RepoTable,
  },
  watch: {
    // call again the method if the route changes
    $route: "Home",
  },
  created() {
    Promise.all([this.fetchRepoData(), this.fetchOrgs()]).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    async fetchRepoData() {
      this.items = await this.$client.get("repositories/");
    },
    async fetchOrgs() {
      this.chunks = _.chunk(
        Object.values(await this.$client.get("organizations/")),
        3
      );
    },
  },
};
</script>

<style scoped>
.orgRow {
  margin-bottom: 15px;
}


.repositories-title {
  align-items: center;
}

.repositories-badge {
  margin-left: 5px; /* Adjust this value as needed */
  margin-top: -2px; /* Adjust this value as needed */
  vertical-align: middle;
}

</style>
